import { ChartBounds, BarData } from './types';
import { getColor } from './chartUtils';

interface KeisukeBarProps {
  bounds: ChartBounds;
  data: BarData[];
  xScale: (value: string) => number;
  yScale: (value: number) => number;
  barWidth?: number;
  /** 棒間の余白比率（0〜0.6）。親が xScale で gapPx を既に反映している場合は 0 を渡す */
  barSpacing?: number;
  errorBarColor?: string;
  /** 棒の枠線色（レガシー計助風は #000000） */
  barStrokeColor?: string;
}

/**
 * KeisukeBar - 棒グラフコンポーネント（エラーバー付き）
 */
export default function KeisukeBar({
  bounds,
  data,
  xScale,
  yScale,
  barWidth = 40,
  barSpacing = 0.3,
  errorBarColor = '#666666',
  barStrokeColor = '#333333',
}: KeisukeBarProps) {
  if (data.length === 0) return null;

  const spacing = Math.max(0, Math.min(0.6, barSpacing));
  const barSpacingPx = (bounds.width / data.length) * spacing; // バー間のスペース
  const availableWidth = bounds.width - barSpacingPx * (data.length - 1);
  const calculatedBarWidth = Math.min(barWidth, availableWidth / data.length);

  return (
    <g>
      {data.map((item, index) => {
        const x = bounds.x + xScale(item.name) - calculatedBarWidth / 2;
    const barY = yScale(item.value);
    const barHeight = bounds.y + bounds.height - barY;
        const color = item.color || getColor(index);

        return (
          <g key={item.name}>
            {/* エラーバー */}
            {item.errorBar && (
              <g>
                {/* エラーバーの縦線 */}
                <line
                  x1={x + calculatedBarWidth / 2}
                  y1={yScale(item.errorBar.upper)}
                  x2={x + calculatedBarWidth / 2}
                  y2={yScale(item.errorBar.lower)}
                  stroke={errorBarColor}
                  strokeWidth="1.5"
                />
                {/* エラーバーの上端 */}
                <line
                  x1={x + calculatedBarWidth / 2 - 5}
                  y1={yScale(item.errorBar.upper)}
                  x2={x + calculatedBarWidth / 2 + 5}
                  y2={yScale(item.errorBar.upper)}
                  stroke={errorBarColor}
                  strokeWidth="1.5"
                />
                {/* エラーバーの下端 */}
                <line
                  x1={x + calculatedBarWidth / 2 - 5}
                  y1={yScale(item.errorBar.lower)}
                  x2={x + calculatedBarWidth / 2 + 5}
                  y2={yScale(item.errorBar.lower)}
                  stroke={errorBarColor}
                  strokeWidth="1.5"
                />
              </g>
            )}

            {/* 棒 */}
            <rect
              x={x}
              y={barY}
              width={calculatedBarWidth}
              height={barHeight}
              fill={color}
              stroke={barStrokeColor}
              strokeWidth="1"
            />
          </g>
        );
      })}
    </g>
  );
}

